import { render, staticRenderFns } from "./RcvPD_Vendor.vue?vue&type=template&id=76309357"
import script from "./RcvPD_Vendor.vue?vue&type=script&lang=js"
export * from "./RcvPD_Vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports